type ContainerType = {
	isSmallScreen: boolean;
	isMediumScreen: boolean;
};

export const rightContainerStyle = ({ isSmallScreen, isMediumScreen }: ContainerType) => ({
	padding: isSmallScreen
		? '2rem 1.5rem 2.375rem'
		: isMediumScreen
		? '1.875rem 2.5rem 1.875rem'
		: '3.75rem 5rem 3.75rem',
	borderWidth: isSmallScreen ? 0 : '0.0625rem',
	borderStyle: 'solid',
	borderColor: 'neutrals.primary',
	borderTopRightRadius: isSmallScreen ? 0 : '0.5rem',
	borderBottomRightRadius: isSmallScreen ? 0 : '0.5rem',
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '1.875rem',
});

export const leftContainerStyle = ({ isSmallScreen, isMediumScreen }: ContainerType) => ({
	padding: isSmallScreen
		? '2rem 1.5rem 2.375rem'
		: isMediumScreen
		? '1.875rem 2.5rem 1.875rem'
		: '3.75rem 5rem 3.75rem',
	borderTopLeftRadius: isSmallScreen ? 0 : '0.5rem',
	borderBottomLeftRadius: isSmallScreen ? 0 : '0.5rem',
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '1.875rem',
	backgroundColor: 'primary.main',
});

export const containerWrapper = (isSmallScreen: boolean) => ({
	minWidth: '100%',
	padding: isSmallScreen ? '0 0 1.9375rem 0' : '1.5rem 3.75rem 1.9375rem 3.75rem',
	flex: 1,
	display: 'flex',
	flexDirection: isSmallScreen ? 'column-reverse' : 'row',
});

export const title = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		padding: '0 1.25rem',
		alignItems: 'center',
	},
	header: { padding: '2.5rem 0 0.75rem' },
};

export const submitButton = { padding: '1rem 1.5rem' };
